import { queryOptions } from "@tanstack/react-query";
import { TNotesType } from "components/Dashboard/DoctorDashboard/notes-and-forms/types";
import { sortBy } from "lodash";
import querySchema from "services/querySchema";
import querySchemas from "services/querySchemas";

export const listSchemasQueryOptions = <T extends TNotesType>(type: T) => {
  return queryOptions({
    queryKey: [`${type}-schema`],
    queryFn: () => querySchemas(type),
    select: (data) => {
      const filteredData =
        type === "form"
          ? data.filter((el) => (el as FormSchema).form_type === "custom")
          : type === "assessment"
          ? data.filter((el) => (el as FormSchema).form_type === "assessment")
          : data;
      return sortBy(filteredData, "title");
    },
  });
};

export const getSchemaQueryOptions = <T extends TNotesType>(
  type: T,
  params: {
    id: number | string;
    revision?: number | string;
  },
) => {
  return queryOptions({
    queryKey: [`${type}-schema`, params],
    queryFn: () =>
      querySchema({
        type,
        ...params,
      }),
  });
};
